import { AiChatContext } from '@fb/models';

import {
  AI_CHAT_DEFAULT_CONTEXT,
  AI_CHAT_LAST_TAB_SESSION_KEY,
  AI_CHAT_ROUTE_SEGMENT,
} from './ai-chat.constants';

/** Map shell URL path to context using {@link AI_CHAT_ROUTE_SEGMENT}. */
export function contextFromShellPathString(path: string): AiChatContext | null {
  const pathForMatch = path.split('?')[0].split('#')[0].toLowerCase();

  for (const context of [AiChatContext.Work, AiChatContext.Personal]) {
    if (pathForMatch.includes(AI_CHAT_ROUTE_SEGMENT[context])) {
      return context;
    }
  }

  return null;
}

export function readStoredLastChatContext(): AiChatContext {
  if (typeof sessionStorage === 'undefined') {
    return AI_CHAT_DEFAULT_CONTEXT;
  }

  try {
    const raw = sessionStorage.getItem(AI_CHAT_LAST_TAB_SESSION_KEY);

    if (raw === AiChatContext.Work || raw === AI_CHAT_ROUTE_SEGMENT[AiChatContext.Work]) {
      return AiChatContext.Work;
    }

    if (raw === AiChatContext.Personal || raw === AI_CHAT_ROUTE_SEGMENT[AiChatContext.Personal]) {
      return AiChatContext.Personal;
    }

    return AI_CHAT_DEFAULT_CONTEXT;
  } catch {
    return AI_CHAT_DEFAULT_CONTEXT;
  }
}

export function persistLastChatContext(context: AiChatContext): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  try {
    sessionStorage.setItem(AI_CHAT_LAST_TAB_SESSION_KEY, context);
  } catch {
    /* ignore */
  }
}

export function persistLastChatContextFromNavigatePath(path: string): void {
  const context = contextFromShellPathString(path);

  if (context != null) {
    persistLastChatContext(context);
  }
}
